var MyShop;
(function (MyShop) {
    myonce("my-shop", () => {
        const $myShop = document.querySelector('.my-shop');
        if ($myShop) {
            const allFavouriteStore = {
                stores: [
                    {
                        id: 42,
                        name: "Milano Arona forage",
                        logo: "https://local.coop.it/sites/default/files/2020-05/alleanza2x.jpg",
                        address: "Via Arona 18",
                        city: "Milano",
                        province: "MI",
                        phone: "023188233",
                        geo: {
                            latitude: 45.5254657,
                            longitude: 9.225220499999999
                        },
                        extraordinary_schedule: [
                            {
                                date: "2020-04-20T08:00:00+02:00",
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            }
                        ],
                        schedules: [
                            {
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            },
                            {
                                value: "08:30-21:00",
                                status: true,
                                dayOfTheWeek: 2
                            },
                            {
                                value: "",
                                status: false,
                                dayOfTheWeek: 7
                            }
                        ],
                        promotions: [
                            {
                                id: "PROMO122",
                                title: "Piante e fiori Coop",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            },
                            {
                                id: "N",
                                title: "Promo N",
                                description: "Solo fino a domenica",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        offers: [
                            {
                                id: "OFFER123",
                                title: "Volantino Amici di casa",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/vol123",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            },
                            {
                                id: "N",
                                title: "Volantino N",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/volN",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            }
                        ],
                        services: [
                            {
                                id: "climate",
                                label: "Climatizzazione",
                                category: "base-services"
                            },
                            {
                                id: "celiachia",
                                label: "Accettazione buoni celiachia",
                                category: "structure"
                            },
                            {
                                id: "buoni-pasto",
                                label: "Buoni pasto",
                                category: "payment-methods"
                            }
                        ],
                        "service-categories": [
                            {
                                id: "base-services",
                                label: "Servizi"
                            },
                            {
                                id: "structure",
                                label: "Reparti"
                            },
                            {
                                id: "payment-methods",
                                label: "Metodi di pagamento"
                            },
                            {
                                id: "service-n",
                                label: "Categoria aggiuntiva"
                            }
                        ]
                    },
                    {
                        id: 45,
                        name: "Milano Arona forage 2",
                        logo: "https://local.coop.it/sites/default/files/2020-05/alleanza2x.jpg",
                        address: "Via Arona 18",
                        city: "Milano",
                        province: "MI",
                        phone: "023188233",
                        geo: {
                            latitude: 45.5254657,
                            longitude: 9.225220499999999
                        },
                        extraordinary_schedule: [
                            {
                                date: "2020-04-20T08:00:00+02:00",
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            }
                        ],
                        schedules: [
                            {
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            },
                            {
                                value: "08:30-21:00",
                                status: true,
                                dayOfTheWeek: 2
                            },
                            {
                                value: "",
                                status: false,
                                dayOfTheWeek: 7
                            }
                        ],
                        promotions: [
                            {
                                id: "PROMO122",
                                title: "Piante e fiori Coop",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            },
                            {
                                id: "N",
                                title: "Promo N",
                                description: "Solo fino a domenica",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        offers: [
                            {
                                id: "OFFER123",
                                title: "Volantino Amici di casa",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/vol123",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            },
                        ],
                        services: [
                            {
                                id: "climate",
                                label: "Climatizzazione",
                                category: "base-services"
                            },
                            {
                                id: "celiachia",
                                label: "Accettazione buoni celiachia",
                                category: "structure"
                            },
                            {
                                id: "buoni-pasto",
                                label: "Buoni pasto",
                                category: "payment-methods"
                            }
                        ],
                        "service-categories": [
                            {
                                id: "base-services",
                                label: "Servizi"
                            },
                            {
                                id: "structure",
                                label: "Reparti"
                            },
                            {
                                id: "payment-methods",
                                label: "Metodi di pagamento"
                            },
                            {
                                id: "service-n",
                                label: "Categoria aggiuntiva"
                            }
                        ]
                    },
                    {
                        id: 50,
                        name: "Milano Arona forage 3",
                        logo: "https://local.coop.it/sites/default/files/2020-05/alleanza2x.jpg",
                        address: "Via Arona 18",
                        city: "Milano",
                        province: "MI",
                        phone: "023188233",
                        geo: {
                            latitude: 45.5254657,
                            longitude: 9.225220499999999
                        },
                        extraordinary_schedule: [
                            {
                                date: "2020-04-20T08:00:00+02:00",
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            }
                        ],
                        schedules: [
                            {
                                value: "09:00-22:00",
                                status: true,
                                dayOfTheWeek: 1
                            },
                            {
                                value: "08:30-21:00",
                                status: true,
                                dayOfTheWeek: 2
                            },
                            {
                                value: "",
                                status: false,
                                dayOfTheWeek: 7
                            }
                        ],
                        promotions: [
                            {
                                id: "PROMO122",
                                title: "Piante e fiori Coop",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            },
                            {
                                id: "N",
                                title: "Promo N",
                                description: "Solo fino a domenica",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            },
                            {
                                id: "L",
                                title: "Promo L",
                                description: "Solo fino a febbraio",
                                uri: "https://www.promo.coop.it/promo122",
                                image: "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        offers: [
                            {
                                id: "OFFER123",
                                title: "Volantino Amici di casa",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/vol123",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            },
                            {
                                id: "N",
                                title: "Volantino N",
                                description: "Dal 7 al 21 novembre",
                                uri: "https://www.promo.coop.it/volN",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            },
                            {
                                id: "H",
                                title: "Volantino H",
                                description: "Dal 15 al 30 novembre",
                                uri: "https://www.promo.coop.it/volN",
                                image: "https://www.cdn.it/static/volantino123.jpg"
                            }
                        ],
                        services: [
                            {
                                id: "climate",
                                label: "Climatizzazione",
                                category: "base-services"
                            },
                            {
                                id: "celiachia",
                                label: "Accettazione buoni celiachia",
                                category: "structure"
                            },
                            {
                                id: "buoni-pasto",
                                label: "Buoni pasto",
                                category: "payment-methods"
                            }
                        ],
                        "service-categories": [
                            {
                                id: "base-services",
                                label: "Servizi"
                            },
                            {
                                id: "structure",
                                label: "Reparti"
                            },
                            {
                                id: "payment-methods",
                                label: "Metodi di pagamento"
                            },
                            {
                                id: "service-n",
                                label: "Categoria aggiuntiva"
                            }
                        ]
                    }
                ],
            };
            const storeDetail42 = {
                resultCode: 1,
                "stores": [
                    {
                        "id": 42,
                        "name": "Milano Arona",
                        "cooperativa": "coop-lombardia",
                        "logo": "https://www.cdn.it/static/logo-coop-arona.png",
                        "storeImage": "https://www.cdn.it/static/image-coop-arona.jpg",
                        "address": "Via Arona 18",
                        "city": "Milano",
                        "province": "MI",
                        "region": "Lombaria",
                        "cap": 20100,
                        "phone": "023188233",
                        "geo": {
                            "latitude": 50.1233,
                            "longitude": -9.2335
                        },
                        "flagType": {
                            "id": 1,
                            "value": "supermercato"
                        },
                        "extraordinary_schedule": [
                            {
                                "date": "2020-04-20T08:00:00+02:00",
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "date": "2020-04-21T08:00:00+02:00",
                                "status": false,
                                "dayOfTheWeek": 1 
                            }
                        ],
                        "schedules": [
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 2 
                            },
                            {
                                "value": "",
                                "status": false,
                                "dayOfTheWeek": 7 
                            }
                        ],
                        "promotions": [
                            {
                                "id": "PROMO122",
                                "title": "Piante e fiori Coop",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg",
                            },
                            {
                                "id": "N",
                                "title": "Promo N",
                                "description": "Solo fino a domenica",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        "offers": [
                            {
                                "id": "OFFER123",
                                "title": "Volantino Amici di casa",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/vol123",
                                "image": "https://i.picsum.photos/id/110/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/210/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/310/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/430/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/180/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/999/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/98/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/87/200/300.jpg"
                            }
                        ],
                        "attributes": {
                            "departments": {
                                "122": "Corner Ottica",
                                "135": "Alimentari per neonati" 
                            },
                            "services": {
                                "543": "Stampa foto",
                                "789": "Accettazione buoni pasto"
                            },
                            "paymentMethods": {
                                "1": "Carta socio Coop",
                                "2": "Carta di credito"
                            }
                        }
                    }
                ]
            };
            const storeDetail45 = {
                resultCode: 1,
                "stores": [
                    {
                        "id": 45,
                        "name": "Milano Arona",
                        "cooperativa": "coop-lombardia",
                        "logo": "https://www.cdn.it/static/logo-coop-arona.png",
                        "storeImage": "https://www.cdn.it/static/image-coop-arona.jpg",
                        "address": "Via Arona 18",
                        "city": "Milano",
                        "province": "MI",
                        "region": "Lombaria",
                        "cap": 20100,
                        "phone": "023188233",
                        "geo": {
                            "latitude": 50.1233,
                            "longitude": -9.2335
                        },
                        "flagType": {
                            "id": 1,
                            "value": "supermercato"
                        },
                        "extraordinary_schedule": [
                            {
                                "date": "2020-04-20T08:00:00+02:00",
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "date": "2020-04-21T08:00:00+02:00",
                                "status": false,
                                "dayOfTheWeek": 1 
                            }
                        ],
                        "schedules": [
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 2 
                            },
                            {
                                "value": "",
                                "status": false,
                                "dayOfTheWeek": 7 
                            }
                        ],
                        "promotions": [
                            {
                                "id": "PROMO122",
                                "title": "Piante e fiori Coop",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg",
                            },
                            {
                                "id": "N",
                                "title": "Promo N",
                                "description": "Solo fino a domenica",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        "offers": [
                            {
                                "id": "OFFER123",
                                "title": "Volantino Amici di casa",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/vol123",
                                "image": "https://i.picsum.photos/id/110/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/210/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/310/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/430/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/180/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            }
                        ],
                        "attributes": {
                            "departments": {
                                "122": "Corner Ottica",
                                "135": "Alimentari per neonati" 
                            },
                            "services": {
                                "543": "Stampa foto",
                                "789": "Accettazione buoni pasto"
                            },
                            "paymentMethods": {
                                "1": "Carta socio Coop",
                                "2": "Carta di credito"
                            }
                        }
                    }
                ]
            };
            const storeDetail50 = {
                resultCode: 1,
                "stores": [
                    {
                        "id": 50,
                        "name": "Milano Arona",
                        "cooperativa": "coop-lombardia",
                        "logo": "https://www.cdn.it/static/logo-coop-arona.png",
                        "storeImage": "https://www.cdn.it/static/image-coop-arona.jpg",
                        "address": "Via Arona 18",
                        "city": "Milano",
                        "province": "MI",
                        "region": "Lombaria",
                        "cap": 20100,
                        "phone": "023188233",
                        "geo": {
                            "latitude": 50.1233,
                            "longitude": -9.2335
                        },
                        "flagType": {
                            "id": 1,
                            "value": "supermercato"
                        },
                        "extraordinary_schedule": [
                            {
                                "date": "2020-04-20T08:00:00+02:00",
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "date": "2020-04-21T08:00:00+02:00",
                                "status": false,
                                "dayOfTheWeek": 1 
                            }
                        ],
                        "schedules": [
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 1 
                            },
                            {
                                "value": "09:00-13:00;14:00-22:00",
                                "status": true,
                                "dayOfTheWeek": 2 
                            },
                            {
                                "value": "",
                                "status": false,
                                "dayOfTheWeek": 7 
                            }
                        ],
                        "promotions": [
                            {
                                "id": "PROMO122",
                                "title": "Piante e fiori Coop",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg",
                            },
                            {
                                "id": "N",
                                "title": "Promo N",
                                "description": "Solo fino a domenica",
                                "uri": "https://www.promo.coop.it/promo122",
                                "image": "https://www.cdn.it/static/promo122.jpg"
                            }
                        ],
                        "offers": [
                            {
                                "id": "OFFER123",
                                "title": "Volantino Amici di casa",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/vol123",
                                "image": "https://i.picsum.photos/id/110/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/210/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/310/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/430/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/180/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            },
                            {
                                "id": "N",
                                "title": "Volantino N",
                                "description": "Dal 7 al 21 novembre",
                                "uri": "https://www.promo.coop.it/volN",
                                "image": "https://i.picsum.photos/id/10/200/300.jpg"
                            }
                        ],
                        "attributes": {
                            "departments": {
                                "122": "Corner Ottica",
                                "135": "Alimentari per neonati" 
                            },
                            "services": {
                                "543": "Stampa foto",
                                "789": "Accettazione buoni pasto"
                            },
                            "paymentMethods": {
                                "1": "Carta socio Coop",
                                "2": "Carta di credito"
                            }
                        }
                    }
                ]
            };
            const offersVisited = [];
            const getFavouriteStore = () => {
                const $saveData = document.querySelector('#save-data');
                if ($saveData) {
                    $saveData.addEventListener('click', () => {
                        localforage.setItem('favourite_store', allFavouriteStore);
                    });
                }
                let $storeWrapper = document.querySelector('.favourite-shop-wrapper');
                const $favouriteStore = document.querySelector('.my-shop-card');
                const $blockTrainCard = document.querySelector('.block-train-card');
                localforage.getItem('favourite_store').then((shops) => {
                    const myStores = shops.stores.filter(shop => {
                        return !shop.deleted;
                    });
                    if (myStores.length >= 1) {
                        for (let i = 0; i < myStores.length; i++) {
                            const store = myStores[i];
                            const carouselItem = document.createElement('div');
                            carouselItem.className = "carousel__item";
                            let nextStore = $favouriteStore.cloneNode(true);
                            carouselItem.appendChild(nextStore);
                            populateStoreDatas(nextStore, store);
                            $storeWrapper.appendChild(carouselItem);
                        }
                        initCarousel();
                        getStoreDetail(myStores[0].id);
                        initCarousel().on(function () {
                            let activeStoreId = document.querySelector('.active .my-shop-card').getAttribute('data-id');
                            getStoreDetail(activeStoreId);
                        });
                    }
                    else {
                        const p = document.createElement('p');
                        p.innerHTML = 'Non sono presenti store tra i preferiti.';
                        $storeWrapper.appendChild(p);
                        $blockTrainCard.style.display = 'none';
                    }
                });
            };
            function getStoreDetail(id) {
                const $blockTrainCard = document.querySelector('.block-train-card');
                const offersWrapper = $blockTrainCard.querySelector('.offers');
                const dummyElement = $blockTrainCard.querySelector('.slide.type-2');
                const elementsContainer = offersWrapper.querySelector('.offers-container');
                const storeId = Number(id);
                let storeOffers = {
                    id: storeId,
                    offers: [],
                };
                let offers;
                let list;
                let sessionList = JSON.parse(sessionStorage.getItem('offers-visited'));
                let isStoreSaved = false;
                if (sessionList) {
                    for (let i = 0; i < sessionList.length; i++) {
                        if (sessionList[i].id === storeId) {
                            isStoreSaved = true;
                        }
                    }
                }
                if (!isStoreSaved) {
                    switch (storeId) {
                        case 42:
                            storeOffers.offers = storeDetail42.stores[0].offers;
                            break;
                        case 45:
                            storeOffers.offers = storeDetail45.stores[0].offers;
                            break;
                        case 50:
                            storeOffers.offers = storeDetail50.stores[0].offers;
                            break;
                    }
                    offersVisited.push(storeOffers);
                    sessionStorage.setItem('offers-visited', JSON.stringify(offersVisited));
                }
                if (isStoreSaved) {
                    list = sessionList;
                }
                else {
                    list = offersVisited;
                }
                let storeSelected = list.filter(store => {
                    if (store.id == storeId)
                        return store;
                });
                if (elementsContainer.children.length >= 1) {
                    const itemsToRemove = elementsContainer.querySelectorAll('.slide');
                    itemsToRemove.forEach(item => {
                        item.remove();
                    });
                }
                offers = storeSelected[0].offers;
                offersWrapper.querySelector('.title').innerHTML = offers.length + ' Volantini';
                for (let i = 0; i < offers.length; i++) {
                    const store = offers[i];
                    let nextOffer = dummyElement.cloneNode(true);
                    populateOffers(nextOffer, store);
                    elementsContainer.appendChild(nextOffer);
                }
                const $carousel = $blockTrainCard.querySelector('.train-card');
                trigger(document, 'init-train-card', $carousel);
            }
            function populateOffers(nextStore, store) {
                nextStore.classList.remove("dummy");
                nextStore.querySelector(".image").src = store.image;
                nextStore.querySelector(".heading").innerHTML = store.title;
                nextStore.querySelector(".info").innerHTML = store.description;
            }
            function populateStoreDatas(nextStore, store) {
                nextStore.classList.remove("dummy");
                nextStore.setAttribute("data-id", store.id);
                nextStore.querySelector(".name").innerHTML = store.name;
                nextStore.querySelector(".shop-address").innerHTML = store.address;
                nextStore.querySelector(".shop-phone").innerHTML = store.phone;
                const $favouriteBtn = nextStore.querySelector('.favourite-shop');
                $favouriteBtn.addEventListener('click', evt => {
                    $favouriteBtn.classList.toggle('is-favourite');
                    removeFavouriteStore(evt, !$favouriteBtn.classList.contains('is-favourite'));
                });
            }
            function removeFavouriteStore(evt, state) {
                let storeId = evt.target.closest('.my-shop-card').getAttribute('data-id');
                localforage.getItem('favourite_store').then((shops) => {
                    if (shops) {
                        shops.stores.filter(shop => {
                            if (shop.id == storeId) {
                                shop.deleted = state;
                            }
                        });
                        localforage.setItem('favourite_store', shops);
                    }
                });
            }
            getFavouriteStore();
        }
    });
})(MyShop || (MyShop = {}));
